export function buildUserAvatarInitials(displayName = "") {
  const normalizedLabel = String(displayName || "").trim();

  if (!normalizedLabel) {
    return "U";
  }

  const initials = normalizedLabel
    .split(/\s+/u)
    .slice(0, 2)
    .map((part) => part[0] || "")
    .join("")
    .toUpperCase();

  return initials || "U";
}

export function resolveUserAvatarGenderVariant(source = {}) {
  const profileType = String(
    source?.profile?.profileType || source?.profileType || ""
  ).toLowerCase();

  if (profileType === "femme")   return "feminine";
  if (profileType === "homme")   return "masculine";
  if (profileType === "couple")  return "couple";
  return "neutral";
}

function isUsableAvatarUrl(value) {
  const candidate = String(value || "").trim();

  if (!candidate) {
    return false;
  }

  return (
    /^https?:\/\//i.test(candidate) ||
    /^data:image\//i.test(candidate) ||
    /^blob:/i.test(candidate) ||
    candidate.startsWith("/") ||
    candidate.startsWith("//")
  );
}

export function resolveUserAvatarUrl(source = {}, explicitSrc = "") {
  if (isUsableAvatarUrl(explicitSrc)) {
    return String(explicitSrc).trim();
  }

  if (typeof source === "string" && isUsableAvatarUrl(source)) {
    return source.trim();
  }

  const primaryMediaPhoto = Array.isArray(source?.media?.photos)
    ? source.media.photos[0]
    : null;
  const candidates = [
    primaryMediaPhoto?.thumbnailUrl,
    primaryMediaPhoto?.url,
    source?.photoURL,
    source?.photoUrl,
    source?.avatar,
    source?.avatarUrl,
    source?.image,
  ];

  return (
    candidates.find(
      (value) => typeof value === "string" && isUsableAvatarUrl(value)
    ) || ""
  );
}
